module.exports = __webpack_public_path__ + "static/media/students.6afdf9b6.png";